"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAuth = initializeAuth;
var AuthContextState_1 = require("../context/AuthContextState");
var AppContextState_1 = require("../../AppContext/AppContextState");
var services_1 = require("../../../api/services");
var api_1 = require("../../../api");
var feature_flag_service_1 = require("../../../api/services/feature-flag.service");
var local_storage_helper_1 = require("../../../api/helpers/local-storage.helper");
var local_storage_enum_1 = require("../../../api/constants/local-storage.enum");
var cms_1 = require("../../GlobalNav/v2/service/cms");
function initializeAuth(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var authContextState, appContextState, configuration, userService, profileInfoResponse, xSessionStateOfProfileInfo, authService, retryOptionsOnNonAuthorized, schoolYearService, classService, curriculumService, contextState, configurationService, schoolYear, err_1, error, setFeatureFlagInLocalStorage, _c, classes, cmsCurricula, licenseCurricula_1, configurationObj, impersonatorProfileHTTPResponse, curricula;
        var _d = _b.featureFlag, featureFlag = _d === void 0 ? false : _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    authContextState = new AuthContextState_1.AuthContextState();
                    appContextState = new AppContextState_1.AppContextState();
                    configuration = new api_1.Configuration();
                    userService = services_1.UserService.newInstance({
                        authContextState: authContextState,
                    });
                    return [4 /*yield*/, userService.findCurrentWithHeaders()];
                case 1:
                    profileInfoResponse = _e.sent();
                    if (!(profileInfoResponse === null || profileInfoResponse === void 0 ? void 0 : profileInfoResponse.user)) return [3 /*break*/, 7];
                    xSessionStateOfProfileInfo = JSON.parse(profileInfoResponse.headers['x-session-state']);
                    authService = services_1.AuthService.newInstance({ authContextState: authContextState });
                    retryOptionsOnNonAuthorized = authService.retryOptionsOnNonAuthorized();
                    schoolYearService = services_1.SchoolYearService.newInstance({
                        authContextState: authContextState,
                        retryOptionsOnNonAuthorized: retryOptionsOnNonAuthorized,
                    });
                    classService = services_1.ClassService.newInstance({
                        authContextState: authContextState,
                        retryOptionsOnNonAuthorized: retryOptionsOnNonAuthorized,
                    });
                    curriculumService = services_1.CurriculumService.newInstance({
                        authContextState: authContextState,
                        retryOptionsOnNonAuthorized: retryOptionsOnNonAuthorized,
                    });
                    contextState = api_1.ServiceContextState.newInstance({ authContextState: authContextState });
                    configurationService = contextState.configurationService;
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, schoolYearService.findCurrent()];
                case 3:
                    schoolYear = _e.sent();
                    authContextState.setSchoolYear(schoolYear);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _e.sent();
                    error = err_1;
                    if (error.response.status === 404) {
                        authContextState.setSchoolYear(undefined);
                    }
                    return [3 /*break*/, 5];
                case 5:
                    authContextState.setUser(profileInfoResponse.user);
                    setFeatureFlagInLocalStorage = function () {
                        if (!(0, local_storage_helper_1.getObjectFromLocalStorage)(local_storage_enum_1.LocalStorageKeys.AffirmFeatureFlags)) {
                            var featureFlagService = feature_flag_service_1.FeatureFlagService.newInstance();
                            featureFlagService.getFeatureFlags().then(function (featureFlagResponse) {
                                (0, local_storage_helper_1.storeObjectInLocalStorage)(local_storage_enum_1.LocalStorageKeys.AffirmFeatureFlags, featureFlagResponse);
                            });
                        }
                    };
                    if (featureFlag)
                        setFeatureFlagInLocalStorage();
                    return [4 /*yield*/, Promise.all([
                            classService.findByOwner(authContextState.user),
                            cms_1.CMSService.getCurricula(),
                            curriculumService.findByUser(profileInfoResponse.user.id),
                            configurationService.getConfiguration(),
                            xSessionStateOfProfileInfo.impersonation
                                ? authService.getImpersonatorProfile()
                                : Promise.resolve(null),
                        ])];
                case 6:
                    _c = _e.sent(), classes = _c[0], cmsCurricula = _c[1], licenseCurricula_1 = _c[2], configurationObj = _c[3], impersonatorProfileHTTPResponse = _c[4];
                    curricula = cmsCurricula.map(function (item) {
                        var _a, _b;
                        return new api_1.Curriculum({
                            id: item.internalId,
                            name: item.title,
                            description: item.description,
                            grades: ((_b = (_a = licenseCurricula_1 === null || licenseCurricula_1 === void 0 ? void 0 : licenseCurricula_1.find) === null || _a === void 0 ? void 0 : _a.call(licenseCurricula_1, function (licenseCurriculum) { return licenseCurriculum.id === item.internalId; })) === null || _b === void 0 ? void 0 : _b.grades) || [],
                        });
                    });
                    appContextState.setClasses(classes);
                    appContextState.setConfiguration(configurationObj);
                    appContextState.setCurriculums(curricula);
                    appContextState.setLicensedCurriculums(curricula);
                    if (xSessionStateOfProfileInfo.impersonation) {
                        authContextState.setImpersonation(xSessionStateOfProfileInfo.impersonation);
                        authContextState.setImpersonatorProfile(impersonatorProfileHTTPResponse.body);
                    }
                    configuration = configurationObj;
                    _e.label = 7;
                case 7: return [2 /*return*/, { authContextState: authContextState, appContextState: appContextState, configuration: configuration }];
            }
        });
    });
}
